import axios from 'axios';
import {CLIENT_VERSION_HEADER, getClientBuildVersion} from '@/utils/api/versionApi';
import {getPlatformAccessToken} from './session';
import {refreshSession, installSessionInterceptor, lockSession} from '@/utils/sessionSecurity';
const platformApi = axios.create({baseURL: '/api/platform', withCredentials: true});
platformApi.interceptors.request.use(config => {
    config.headers = config.headers || {};
    const token = getPlatformAccessToken();
    if (token) config.headers.Authorization = `Bearer ${token}`;
    else delete config.headers.Authorization;
    config.headers[CLIENT_VERSION_HEADER] = getClientBuildVersion();
    return config;
});
installSessionInterceptor(platformApi, 'platform');
export const refreshPlatformSession = () => refreshSession('platform');
export const clearSessionAndRedirect = error => lockSession('platform', error);
export default platformApi;
